// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/* tslint:disable */
/* eslint-disable */
import "../textstyles/fonts.css";
import "../reset.css";
import "./IconButton.css";
import React, { createContext, useContext } from "react";
import {
  exists,
  findSetVariantProps,
  makeCompositeDefaultProps,
} from "../_internal_utils";
import { ContainerPrimitive, IconPrimitive } from "../_internal_primitives";
import { ButtonRoot } from "../_internal_button";
import * as icons from "../icons";

const styles = [
  {
    type: "default",
    layers: {
      NFYaQaA7WN: {
        none: {
          icon: icons.plus,
          useMask: true,
        },
        disabled: {
          useMask: true,
        },
      },
    },
  },
  {
    type: "enum",
    propName: "size",
    values: [
      {
        propValue: "xlarge",
        layers: {},
      },
      {
        propValue: "large",
        layers: {},
      },
      {
        propValue: "med",
        layers: {},
      },
      {
        propValue: "small",
        layers: {},
      },
      {
        propValue: "xsmall",
        layers: {},
      },
    ],
  },
  {
    type: "boolean",
    propName: "rounded",
    layers: {
      NFYaQaA7WN: {
        none: {
          useMask: true,
        },
      },
    },
  },
  {
    type: "boolean",
    propName: "large",
    layers: {},
  },
];

const defaultPropValues = [
  {
    type: "default",
    layers: {},
  },
  {
    type: "enum",
    propName: "size",
    values: [
      {
        propValue: "xlarge",
        layers: {},
      },
      {
        propValue: "large",
        layers: {},
      },
      {
        propValue: "med",
        layers: {},
      },
      {
        propValue: "small",
        layers: {},
      },
      {
        propValue: "xsmall",
        layers: {},
      },
    ],
  },
  {
    type: "boolean",
    propName: "rounded",
    layers: {},
  },
  {
    type: "boolean",
    propName: "large",
    layers: {},
  },
];

const variantPropTypes = [
  {
    type: "enum",
    propName: "size",
    propValues: ["xlarge", "large", "med", "small", "xsmall"],
  },
  {
    type: "boolean",
    propName: "rounded",
  },
  {
    type: "boolean",
    propName: "large",
  },
];

export const IconButtonContext = createContext(null);

function IconButton(_props) {
  const defaults = useContext(IconButtonContext);
  const props = { ...defaults, ..._props };
  const activeVariants = findSetVariantProps(variantPropTypes, props);
  const getCompositeDefaultProps = makeCompositeDefaultProps(
    defaultPropValues,
    activeVariants
  );
  return (
    <ButtonRoot
      {...props}
      key="root"
      addSpacing={false}
      internal={{
        projectId: "7X7HTLRqyD",
        styles: styles,
        layerId: "root",
        scope: "AHXXCx7dY8",
        activeVariants: activeVariants,
      }}
    >
      {(getStyle) => (
        <ContainerPrimitive
          id={"color-container_YMiHhUJqGs"}
          className={
            "__visly_reset_7X7HTLRqyD __visly_scope_AHXXCx7dY8_YMiHhUJqGs"
          }
          key={"YMiHhUJqGs"}
          addSpacing={false}
          element={getStyle("YMiHhUJqGs", "htmlElement")}
        >
          {
            <IconPrimitive
              id={"Icon_NFYaQaA7WN"}
              className={
                "__visly_reset_7X7HTLRqyD __visly_scope_AHXXCx7dY8_NFYaQaA7WN"
              }
              key={"NFYaQaA7WN"}
              useMask={getStyle("NFYaQaA7WN", "useMask")}
              src={
                exists(props.icon) ? props.icon : getStyle("NFYaQaA7WN", "icon")
              }
            />
          }
        </ContainerPrimitive>
      )}
    </ButtonRoot>
  );
}

IconButton.__variants = [
  {
    name: "size",
    type: "group",
    variants: ["xlarge", "large", "med", "small", "xsmall"],
  },
  {
    name: "rounded",
    type: "variant",
  },
  {
    name: "large",
    type: "variant",
  },
];

export default IconButton;
